import { Injectable, DOCUMENT, inject } from '@angular/core';
import { CommonService } from '@geneplanet/ngx-shop/src/lib/shared';
import {
  Language,
  Location,
  LocationCode,
} from '@geneplanet/ngx-utils/src/lib/localization';
import { CustomLocalizeRouterService } from 'src/app/core/services/custom-localize-router.service';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, Observable } from 'rxjs';
import { COOKIE_DOMAIN, COOKIE_LANG } from 'src/app/app.constants';
import { setLocaleData } from 'src/app/app.utils';
import { environment } from 'src/environments/environment';
import { AnalyticsService } from '@geneplanet/ngx-utils';
import { AncestryService } from 'src/app/ancestry/services/ancestry.service';
import { HttpClient } from '@angular/common/http';

import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private http = inject(HttpClient);
  private commonService = inject(CommonService);
  private localize = inject(CustomLocalizeRouterService);
  private cookieService = inject(CookieService);
  private ancestryService = inject(AncestryService);
  private analyticsService = inject(AnalyticsService);
  private document = inject<Document>(DOCUMENT);
  private translate = inject(TranslateService);

  currentLocation$ = new BehaviorSubject<Location>(null!);

  public readonly currentLocation = toSignal(this.currentLocation$);

  get locationCode(): LocationCode {
    return this.currentLocation$.value.code;
  }

  onLocationChange(location: Location): void {
    this.translate.use(location.lang.code);

    if (environment.rudderStackEnabled) {
      this.analyticsService.locale =
        location.lang.code + '-' + location.code.toUpperCase();
    }
    const expirationDate = new Date(
      new Date().setFullYear(new Date().getFullYear() + 1)
    );

    this.cookieService.set(
      COOKIE_LANG,
      location.code,
      expirationDate,
      '/',
      `${COOKIE_DOMAIN}`
    );

    this.currentLocation$.next(location);
    setLocaleData(location.code);
    this.commonService.setCurrency(location.currency);
    this.commonService.setPartnerId(location.partner.id);

    this.localize.parser.defaultLang = location.code;
    this.localize.changeLanguageWithoutNavigation(location.code);

    this.ancestryService.cleanup();
    this.setHtmlLangAtt(location.lang.code);
  }

  getLocations() {
    return environment.locations;
  }

  public updateLocaleOnServer(location: Location): Observable<void> {
    const data = {
      language: location.lang.longCode,
      languageCode: location.lang.code,
      locationCode: location.code,
    };
    return this.http.put<void>('/api/customers/locale', data);
  }

  private setHtmlLangAtt(code: Language['code']): void {
    const htmlLangCode = code.split('-')[0]; // sets "es-MX" "ex-CO" etc. as "es"
    this.document.documentElement.lang = htmlLangCode;
  }
}
